import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/authContext";
import { Wordmark } from "@/components/Wordmark";
import { ShieldCheck, LayoutDashboard, Music2, Users, CalendarDays, MapPin, Mail, EyeOff, ArrowLeft, LogOut, Send, BadgeCheck } from "lucide-react";

const ITEMS = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
    { to: "/admin/artists", label: "Artists", icon: Music2 },
    { to: "/admin/users", label: "Users", icon: Users },
    { to: "/admin/events", label: "Events", icon: CalendarDays },
    { to: "/admin/venues", label: "Venues", icon: MapPin },
    { to: "/admin/invitations", label: "Invitations", icon: Mail },
    { to: "/admin/digests", label: "Digests", icon: Send },
    { to: "/admin/verification", label: "Verification", icon: BadgeCheck },
    { to: "/admin/moderation", label: "Moderation", icon: EyeOff },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();

    return (
        <div className="relative min-h-screen flex flex-col md:flex-row bg-[#0a0a0a]" data-testid="admin-layout">
            <aside className="bg-[#0a0a0a] border-r border-[#2a2a2a] w-full md:w-[240px] md:fixed md:top-0 md:bottom-0 md:left-0 md:z-40 md:flex md:flex-col">
                <div className="hidden md:flex items-center h-16 px-6 border-b border-[#2a2a2a]">
                    <Link to="/" className="flex items-center gap-2">
                        <Wordmark small />
                    </Link>
                </div>
                <div className="px-6 py-4 border-b border-[#2a2a2a]">
                    <div className="text-[10px] uppercase tracking-widest text-[#ff4400] font-mono flex items-center gap-1">
                        <ShieldCheck className="w-3 h-3" /> Platform Admin
                    </div>
                    <div className="mt-1 font-display font-bold text-sm truncate" data-testid="admin-user-email">
                        {user?.email || "—"}
                    </div>
                </div>
                <nav className="flex-1 py-3 overflow-x-auto md:overflow-visible md:flex-col flex flex-row md:flex-none">
                    {ITEMS.map((it) => {
                        const Icon = it.icon;
                        return (
                            <NavLink
                                key={it.to}
                                to={it.to}
                                end={it.end}
                                data-testid={`admin-nav-${it.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-6 py-3 text-sm font-display font-bold uppercase tracking-wider border-l-2 whitespace-nowrap transition-colors ${
                                        isActive ? "border-[#ff4400] text-[#ff4400] bg-[#141414]" : "border-transparent text-[#f4f4f0] hover:text-[#ff4400] hover:bg-[#141414]"
                                    }`
                                }
                            >
                                <Icon className="w-4 h-4" />
                                {it.label}
                            </NavLink>
                        );
                    })}
                </nav>
                <div className="border-t border-[#2a2a2a] px-6 py-4 space-y-2">
                    <button onClick={logout} className="pm-btn text-xs w-full" data-testid="admin-logout-btn">
                        <LogOut className="w-3 h-3 mr-2" /> Log out
                    </button>
                    <Link to="/" className="flex items-center gap-2 text-xs font-mono uppercase text-[#a3a3a3] hover:text-[#ff4400]">
                        <ArrowLeft className="w-3 h-3" /> Back to site
                    </Link>
                </div>
            </aside>
            <main className="flex-1 relative z-10 min-w-0 md:ml-[240px]">
                <Outlet />
            </main>
        </div>
    );
}
